import { Box, Button, Modal } from '@mui/material';
import React from 'react';

import styles from './SeriesInfoModal.module.scss';
import { useDispatch } from 'react-redux';
import { postUnreserveMarkingCodeRequest } from '../services/actions';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 510,
  height: 240,
  bgcolor: '#ECEFF1 !important',
  boxShadow: 24,
  p: 4,
  fontSize: '13px !important',
};

interface Props {
  isShown: boolean;
  params: any;
  seriesDetailedParams: any;
  closeModal: () => void;
}

export const SeriesInnerModal: React.FC<Props> = ({ isShown, params, seriesDetailedParams, closeModal }) => {
  const dispatch = useDispatch();

  return (
    <Modal
      open={isShown}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <span className={styles.title}>Виконуйте із застереженням нижче!</span>
        <div className={styles.text}>
          <span>
            Оперерація пересе в Банк кодів і дозволить повторний друк всіх неагрегованих упаковок даного завдання, які
            не агреговано або не вилучено. Для запобіганя дублів агрегуйте всі упаковки в тимчасові ящики, які пізніше
            деагрегуєте.
          </span>
        </div>

        <div className={styles.btnGroupInner}>
          <Button
            className={styles.submitBtn}
            variant="contained"
            onClick={() => {
              dispatch(postUnreserveMarkingCodeRequest({ params, seriesDetailedParams }));
              closeModal();
            }}
          >
            <span className={styles.btnText}>Виконати</span>
          </Button>
          <Button className={styles.exitBtn} variant="contained" onClick={closeModal}>
            <span className={styles.btnText}>Скасувати</span>
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
